// Function to scroll ornave breadcrumbs to the end with delay
function scrollOrnaveToEnd() {
  const breadcrumbsElement = document.getElementById('ornave-breadcrumbs');
  if (breadcrumbsElement) {
    // Wait 1 second after finding the element before scrolling
    setTimeout(() => {
      breadcrumbsElement.scrollTo({
        left: breadcrumbsElement.scrollWidth,
        behavior: 'smooth',
      });
    }, 1000);
    return true;
  }
  return false;
}

// Try to scroll immediately in case the element is already present
if (!scrollOrnaveToEnd()) {
  // If element not found, wait for it to be added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          // Check if the added node is the breadcrumbs element
          if (node.id === 'ornave-breadcrumbs') {
            scrollOrnaveToEnd();
            observer.disconnect();
          }
          // Check if the added node contains the breadcrumbs element
          else if (
            node.querySelector &&
            node.querySelector('#ornave-breadcrumbs')
          ) {
            scrollOrnaveToEnd();
            observer.disconnect();
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Fallback: Stop observing after 10 seconds to prevent memory leaks
  setTimeout(() => {
    observer.disconnect();
  }, 10000);
}

// Additional fallback for when the page is fully loaded
window.addEventListener('load', () => {
  setTimeout(() => {
    scrollOrnaveToEnd();
  }, 100);
});
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4cf10008-c5c0-50f1-9aaf-56f15c353e79")}catch(e){}}();
//# debugId=4cf10008-c5c0-50f1-9aaf-56f15c353e79
